import http from '../util/ws/wsService.js'
import EntityServise from './entityService.js';

class ResourceService extends EntityServise {
    constructor() {
        super("regType")
    }

    async getByResourceIdAndStageRequired(resourceId, stageRequired = false) {
        return await http.get(this.routeApi + "/user/s-resource-stage", { resourceId, stageRequired });
    }

}

export default new ResourceService();

